module.exports = require('./InstallmentSellerRenewalApplicationView');
